module.exports = require('./InstallmentSellerRenewalApplicationView');
